// Set the scrollbar height at 50% by setting margin top and bottom at 25%
const animate = () => {
    let $container = $( '.step__type--labelHover .step__answers' );

    if ( $container ) {
        let scrollbarMargin = $container.height() / 4; // Set margin height at 25%

        $container.css('--scrollbar-margin', scrollbarMargin + 'px');
    }
};
window.addEventListener('resize', animate);

module.exports = {
    animate
};
